import {
  Button,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
} from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { TimeMaterialsInvoiceDataGroupByEnum } from "@src/__generated__/graphql";
import { Card } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { PeriodPicker } from "@src/components/widgets/PeriodPicker";
import { FiltersPanelRoot } from "@src/utils/components/filters/components/filters-panel";
import { FiltersPanelFilters } from "@src/utils/components/filters/components/filters-panel-filters";
import { FiltersPanelSearch } from "@src/utils/components/filters/components/filters-panel-search";
import { observer } from "mobx-react-lite";
import { useInvoiceStore } from "../../../store";
import { BudgetItemsGlobalPercentInput } from "./budget-items-global-percent-input";
import { PrepaymentsCard } from "./PrepaymentsCard";
import { ProjectCard } from "./ProjectCard";
import { TimeAndMaterialsProjectCard } from "./TimeAndMaterials";

export const BudgetSplits = observer(function BudgetSplits() {
  const store = useInvoiceStore();

  return (
    <Stack minW="0" spacing="4">
      {store.isTimeAndMaterialsSelected && (
        <Card p="4" minW="0">
          <FiltersPanelRoot filters={store.timeAndMaterialsStore.where}>
            <HStack mb="2" spacing="2">
              <PeriodPicker
                value={store.timeAndMaterialsStore.period}
                onChange={(period) => {
                  store.timeAndMaterialsStore.setPeriod(period);
                  store.timeAndMaterialsStore.fetchInvoiceData();
                }}
              />
              <Menu>
                <MenuButton
                  as={Button}
                  colorScheme="grey"
                  rightIcon={<Icon name="chevron-down" />}
                  variant="outline"
                >
                  <Trans>Group By:</Trans>&nbsp;
                  {store.timeAndMaterialsStore.groupByLabel}
                </MenuButton>
                <MenuList>
                  {Object.entries(TimeMaterialsInvoiceDataGroupByEnum).map(
                    (value) => (
                      <MenuItem
                        key={value[0]}
                        onClick={() => {
                          store.timeAndMaterialsStore.setGroupBy(value[1]);
                          store.timeAndMaterialsStore.fetchInvoiceData();
                        }}
                      >
                        {value[0]}
                      </MenuItem>
                    ),
                  )}
                </MenuList>
              </Menu>
              <FiltersPanelFilters
                menuPlacement="bottom-start"
                innerMenuPlacement="left-start"
              />
              <FiltersPanelSearch
                flex="1"
                inputWidth="full"
                onSearch={store.timeAndMaterialsStore.handleSearch}
              />
            </HStack>
          </FiltersPanelRoot>
        </Card>
      )}
      {!store.isTimeAndMaterialsSelected && <BudgetItemsGlobalPercentInput />}
      {store.isTimeAndMaterialsSelected
        ? store.selectedProjects.map((project) => (
            <TimeAndMaterialsProjectCard key={project.id} />
          ))
        : store.selectedProjects.map((p) => (
            <ProjectCard key={p.id} project={p} />
          ))}
      <PrepaymentsCard />
    </Stack>
  );
});
